import { ofType } from 'redux-observable';
import { map, mergeMap,flatMap } from 'rxjs/operators';
import { from } from 'rxjs';
import { TransformResponse } from './transform';
import {format} from 'one-util-date';
import {
    SETSELECTED,
    SETPATIENTSELECTED,
    SET as PATIENTSET,
    RESET as PATIENTRESET
} from 'one-state-subject/src/types';

import {
    addAction
} from 'one-state-error/src/actions';

import {
    ErrorObject
} from 'one-state-error/src/errorobject';

import {
    setAction, resetAction
} from 'one-state-patientidentifiers/src/actions';
import { InvokeFinesseProxy } from '../../subject/src/index';
/**
 * This Fuction will fetch the data of Patient Identifier
 * from backend api and returns the response and calls
 * subsequent redux action
 * @param context contains the settings etc..
 */
export const fetchIdentifiersEpic = (context: any) => (
    (action$: any) => {
        const errorTime = format(new Date(),'LT');
        const errorDate = format(new Date(),'LL');
        const { server,alertnotification, log, settings: { servers, compatible, epicendpoints:{ patientidentifier,apitoken } } } = context;
        const { finesse_proxy_service } = compatible;
        const { locations = [] } = servers;
        return action$.pipe(
            ofType(SETSELECTED),
            mergeMap((action: any) => {
                /**
                 * @param dataresponse contains the active allergies response
                 */
                let dataresponse: any = action.payload;
                const postIdentifier = (request: any) => {
                    if (request?.id) {
                        let headers = new Headers();
                        headers.set('Authorization', 'Basic ' + apitoken?.token);
                        const data = {
                            "patient_id": request?.id,
                        }
                        let response;
                        if (finesse_proxy_service) {
                            response = InvokeFinesseProxy(patientidentifier + "?patient_id=" + (request?.id ? request.id : ""),
                                "", apitoken, locations, log, 'GET', alertnotification);

                        } else { 
                            response = server.get({
                                headers: headers,
                                path: patientidentifier +"?patient_id="+ (request?.id ? request.id : ""),
                                
                            })
                                .then((identifierresponsefound: any) => identifierresponsefound)
                                .catch((identifiererror: any) => {
                                    log.error(
                                        "ccw-gadget,patientidentifier-epic",
                                        "identifier error", {
                                            identifiererror
                                    }
                                    );
                                    let errorbuild: ErrorObject={
                                        source:"PatientIdentifier",
                                        type:"error",
                                        status:identifiererror?.status,
                                        erroritems:identifiererror?.errors,
                                        error_date: errorDate,
                                        error_time: errorTime
                                    };
                                    return errorbuild;
                                })
                            log.debug(
                                "ccw-gadget,identifier-epic",
                                "PatientIdentifier-epic response", {
                                response
                            });
                        }
                        return from(response)
                    } else {
                        return from([]);
                    }
                }
                //Calling getRequst function here
                //the reason is we need to use pipe function.
                return postIdentifier(dataresponse).
                    pipe(
                        map((identifyres: any) => TransformResponse(identifyres, context))).
                    pipe(
                        flatMap(response => {
                            const actions:any =[
                                setAction(response.identifiers)
                            ];
                            if(response.error){
                                actions.push(addAction(response.error));
                            }
                            return actions;
                        })
                    )
            })
        )
    }
);
/**
 * Listen for component clear and intiate state clear for Active Allergies
 * @param context  contains logger which is used for logging
 */
export const clearIdentifierEpic = (context: any) => (
    (action$: any) => {
        const { log } = context;
        log.debug(
            "ccw-gadget, identifier-epic",
            "clear-patientidentifier-epic", {
        });
        return action$.pipe(
            ofType(PATIENTSET,SETSELECTED, PATIENTRESET, SETPATIENTSELECTED),
            map(action => resetAction())
        )

    }
);